import React from 'react';
import { View, Text, ActivityIndicator, StyleSheet } from 'react-native';
import { useTheme, SPACING, BORDER_RADIUS, TYPOGRAPHY } from '../../theme';
import { useRightDockInset, useLeftDockInset } from '../../store/uiStore';

interface MapLoadingOverlayProps {
  isFirstLoad: boolean;
}

export function MapLoadingOverlay({ isFirstLoad }: MapLoadingOverlayProps) {
  const { colors } = useTheme();
  // Centre the card in the map that's still visible, not under a docked
  // panel (a /structure deep link can open one before structures load).
  const rightDockInset = useRightDockInset();
  // Same reasoning for a left-docked panel — a /plan/<id> link can open the
  // viewer before structures finish loading.
  const leftDockInset = useLeftDockInset();

  if (!isFirstLoad) return null;

  return (
    <View style={[styles.loadingOverlay, { left: leftDockInset, right: rightDockInset }]}>
      <View
        style={[
          styles.loadingCard,
          { backgroundColor: colors.surface, borderColor: colors.border },
        ]}>
        <ActivityIndicator size="large" color={colors.primary} />
        <Text style={[styles.loadingTitle, { color: colors.text }]}>Loading structures</Text>
        <Text style={[styles.loadingSubtitle, { color: colors.textSecondary }]}>
          This only happens once per session
        </Text>
      </View>
    </View>
  );
}

const styles = StyleSheet.create({
  loadingOverlay: {
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    justifyContent: 'center',
    alignItems: 'center',
    zIndex: 50,
  },
  loadingCard: {
    alignItems: 'center',
    paddingHorizontal: SPACING.xl,
    paddingVertical: SPACING.lg,
    borderRadius: BORDER_RADIUS.xl,
    borderWidth: 1,
    gap: SPACING.sm,
  },
  loadingTitle: {
    ...TYPOGRAPHY.button,
  },
  loadingSubtitle: {
    ...TYPOGRAPHY.bodySmall,
    textAlign: 'center',
  },
});
